import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../context/auth";

const ProtectedNewListing = ({ path }: { path: string }) => {
  const { user } = useAuth();

  if (
    path === ROUTES.NEW_LISTING_ROUTE &&
    !user?.completed &&
    user?.roleId! <= 2
  )
    return <Navigate to={ROUTES.COMPELETE_PROFILE_ROUTE} />;

  return <Outlet />;
};

export default ProtectedNewListing;
